import copy from 'copy-to-clipboard';



export default class DPCopyCodeBlock {

	constructor(copyButtonTitle = 'Copy') {
		// use a class selector if available
		let codes = document.querySelectorAll('pre.wp-block-code code');

		codes.forEach((code) => {
			let button = document.createElement('button');

			button.setAttribute('title', copyButtonTitle);
			code.appendChild(button);

			button.addEventListener('click', () => {
				this.copyCode(button, code);
			});

		});
	}


	copyCode(button, code) {
		let text = code.innerText;
		if (copy(text)) {
			$(button).addClass('dpwe-copied');
			setTimeout(() => {
				$(button).removeClass('dpwe-copied');

			}, 1000);

		}
	}

}
